import React, { forwardRef } from 'react'

const ErrorHeaderLogo = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>(({ height = 56, width = 264, ...props }, ref) => (
  <svg
    ref={ref}
    width={width}
    height={height}
    viewBox="0 0 264 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="132"
      cy="28"
      r="28"
      className="fill-background-surface-secondary"
    />
    <circle
      cx="28"
      cy="28"
      r="28"
      className="fill-background-surface-secondary"
    />
    <path
      d="M132 29.4143L139.293 36.7072L140.707 35.293L133.414 28.0001L140.707 20.7072L139.293 19.293L132 26.5859L124.707 19.293L123.293 20.7072L130.586 28.0001L123.293 35.293L124.707 36.7072L132 29.4143Z"
      fill="#E51C00"
    />
    <circle
      cx="236"
      cy="28"
      r="28"
      className="fill-background-surface-secondary"
    />
    <path
      d="M231.583 27.6529L226.049 18.5097C225.913 18.2856 226.075 18 226.338 18H231.456C231.693 18 231.912 18.1234 232.034 18.3252L237.574 27.4794C237.768 27.7996 237.768 28.2004 237.574 28.5206L232.034 37.6748C231.912 37.8766 231.693 38 231.456 38H226.338C226.075 38 225.913 37.7144 226.049 37.4903L231.583 28.3471C231.712 28.1336 231.712 27.8664 231.583 27.6529Z"
      className="fill-background-inverse"
    />
    <path
      d="M240.863 27.6529L235.329 18.5097C235.194 18.2856 235.356 18 235.618 18H240.736C240.973 18 241.192 18.1234 241.314 18.3252L246.855 27.4794C247.048 27.7996 247.048 28.2004 246.855 28.5206L241.314 37.6748C241.192 37.8766 240.973 38 240.736 38H235.618C235.356 38 235.194 37.7144 235.329 37.4903L240.863 28.3471C240.992 28.1336 240.992 27.8664 240.863 27.6529Z"
      className="fill-background-inverse"
    />
    <path
      d="M18 22L28 16L38 22M18 22V34L28 40M18 22L28 28M28 40L38 34V22M28 40V28M38 22L28 28"
      className="stroke-background-inverse"
      strokeWidth="2"
    />
    <line
      x1="61"
      y1="27"
      x2="99"
      y2="27"
      className="stroke-background-inverse"
      strokeOpacity="0.08"
      strokeWidth="2"
      strokeLinecap="round"
      strokeDasharray="4 4"
    />
    <line
      x1="165"
      y1="27"
      x2="203"
      y2="27"
      className="stroke-background-inverse"
      strokeOpacity="0.08"
      strokeWidth="2"
      strokeLinecap="round"
      strokeDasharray="4 4"
    />
  </svg>
))
ErrorHeaderLogo.displayName = 'ErrorHeaderLogo'

export default ErrorHeaderLogo
